<template>
	<div class="">
		<p v-text="description" class="p-2 small"></p>
		<div v-if="habits !== null && habits.length > 0">
			<b-table
				hover
				small
				:items="habits"
				:fields="fields"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				class="small"
				:tbody-tr-class="rowClass"
				:busy="isBusy"
			>
				<template #table-busy>
					<div class="text-center gold my-2">
						<b-spinner class="align-middle"></b-spinner>
						<br />
						<strong>Loading...</strong>
					</div>
				</template>

				<template v-slot:cell(title)="data">
					<span v-if="data.item.start > habitCompleteDuration">
						<i class="fas fa-check pr-2 text-success"></i>
					</span>
					{{ data.item.title }}
				</template>

				<template v-slot:cell(start)="data">
					<stop-watch :timestamp="data.item.start" />
				</template>

				<template v-slot:cell(action)="data">
					<div class="text-right">
						<div
							class="btn btn-link btn-sm"
							@click="habitAction(data.item.id, 'stop')"
							v-b-tooltip.hover
							title="Stop recording this habit"
						>
							<span class="text-secondary"> <i class="far fa-stop-circle"></i></span>
						</div>

						<!-- 						<b-dropdown text="" size="sm" class="p-0">
							<b-dropdown-item href="#" @click="habitAction(data.item.id, 'stop')">
								<span class="text-secondary">
									<i class="far fa-stop-circle"></i> Stop
								</span>
							</b-dropdown-item>

							<b-dropdown-item href="#" @click="habitAction(data.item.id, 'delete')">
								<span class="text-danger"> <i class="fas fa-times"></i> Delete </span>
							</b-dropdown-item>
						</b-dropdown> -->
					</div>
				</template>
			</b-table>
		</div>

		<div class="p-3">
			<b-input-group size="sm">
				<b-form-input
					v-model="new_habit"
					placeholder="What habit do you want to start?"
				></b-form-input>
				<b-input-group-append>
					<b-button size="sm" class="m-0" @click="habitStart()">Create</b-button>
				</b-input-group-append>
			</b-input-group>
		</div>

		<div v-if="habits_archives !== null && habits_archives.length > 0" class="pt-3">
			<p>
				<b>Archives</b>
			</p>

			<b-table
				hover
				small
				:items="habits_archives"
				:fields="fields_archives"
				:sort-by.sync="sortByArchive"
				:sort-desc.sync="sortDescArchive"
				class="small"
				:tbody-tr-class="rowClass"
			>
				<template v-slot:cell(title)="data">
					<span v-if="data.item.start > habitCompleteDuration">
						<i class="fas fa-check pr-2 text-success"></i>
					</span>
					{{ data.item.title }}
				</template>

				<template v-slot:cell(time)="data">
					<span v-text="data.item.time"></span>
				</template>

				<template v-slot:cell(action)="data">
					<div class="text-right">
						<div
							class="btn btn-link btn-sm"
							@click="habitAction(data.item.id, 'delete')"
							v-b-tooltip.hover
							title="Permanently remove this habit"
						>
							<span class="text-secondary"> <i class="fas fa-trash-alt"></i></span>
						</div>

						<!-- 						<b-dropdown text="" size="sm" class="p-0">
							<b-dropdown-item href="#" @click="habitAction(data.item.id, 'delete')">
								<span class="text-danger"> <i class="fas fa-times"></i> Delete </span>
							</b-dropdown-item>
						</b-dropdown> -->
					</div>
				</template>
			</b-table>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import StopWatch from '../components/StopWatch.vue';
import {strUtils} from '../components/FormVaildation.js';

export default {
	name: 'HabitsCard',
	components: {
		StopWatch,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			description: '',

			fields: [
				{
					key: 'title',
					label: 'Habit',
					sortable: false,
					thStyle: 'width:55%;',
				},
				{
					key: 'start',
					label: 'Time (d:h:m:s)',
					sortable: true,
					thStyle: 'width:35%;',
				},
				{
					key: 'action',
					label: '',
					sortable: false,
				},
			],
			fields_archives: [
				{
					key: 'title',
					label: 'Habit',
					sortable: false,
					thStyle: '',
				},
				{
					key: 'time',
					label: 'Duration',
					sortable: true,
					thStyle: '',
				},
				{
					key: 'action',
					label: '',
					sortable: false,
				},
			],

			isBusy: false,

			sortBy: 'start',
			sortByArchive: 'time',
			sortDesc: false,
			sortDescArchive: true,

			habits: null,
			habits_archives: null,

			habitCompleteDuration: 30 * 86400 * 1000 /* 30 days in milliseconds */,
			new_habit: '',
		};
	},
	mounted() {
		this.habitsGet();
	},
	methods: {
		habitStart() {
			let _this = this;
			console.log(_this.new_habit)
			if(strUtils.isEmpty(_this.new_habit) || strUtils.tooLong(_this.new_habit,45)){
				throw Error("Invaild or empty string")
			}
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('user_id', _this.$store.state.profile.id);
			params.append('habit', _this.new_habit);

			var today = new Date();
			var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
			var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
			var dateTime = date + ' ' + time;

			params.append('dateTime', dateTime);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'habitStart',
				data: params,
			})
				.then(function (response) {
					if (response.data.status === 1) {
						_this.habitsGet();
						/*_this.habits = Object.values(response.data.habits);
						_this.habits_archives = Object.values(response.data.habits_archives);*/
					}
					_this.new_habit = '';
				})
				.catch(function (e) {
					console.log('Error: habitStart:' + e);
				});
		},
		habitsGet() {
			let _this = this;
			this.isBusy = true;
			this.habits = null;
			this.habits_archives = null;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('user_id', _this.$store.state.profile.id);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'habitsGet',
				data: params,
			})
				.then(function (response) {
					if (response.data.card.description) {
						_this.description = response.data.card.description;
					}
					if (response.data.card.habits) {
						_this.habits = Object.values(response.data.card.habits);
						_this.habits_archives = Object.values(response.data.card.habits_archives);
					}
					_this.isBusy = false;
				})
				.catch(function (e) {
					console.log('Error: habitsGet:' + e);
				});
		},

		rowClass(item, type) {
			if (!item || type !== 'row') return;
			if (item.start > this.habitCompleteDuration) return 'text-success';
		},

		habitAction(habit_id, type) {
			let _this = this;
			var confirm_text = 'Are you sure you want to delete this habit?';
			if (type == 'stop') {
				confirm_text =
					'Are you sure you want to stop this habit? * Good luck on your next attempt if Yes...';
			}
			var c = confirm(confirm_text);
			if (c === true) {
				let params = new URLSearchParams();

				params.append('token', _this.$store.state.session_id);
				params.append('user_id', _this.$store.state.profile.id);
				params.append('habit_id', habit_id);
				params.append('type', type);

				axios({
					method: 'post',
					url: _this.$store.state.api_url + 'habitAction',
					data: params,
				})
					.then(function (response) {
						if (response.data.status === 1) {
							_this.habitsGet();
							/*this.habits = Object.values(response.data.habits);
							_this.habits_archives = Object.values(response.data.habits_archives);*/
						}
					})
					.catch(function (e) {
						console.log('Error: habitAction:' + e);
					});
			}
		},
	},
	computed: {},
	watch: {},
};
</script>

<style scoped></style>
